module.exports = __webpack_public_path__ + "static/img/y75.74995d4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/view/images/y75.jpg
// module id = o1M6
// module chunks = 1